export function fetchHostUrl(nextPublicWebUrl = null) {
  return nextPublicWebUrl ? nextPublicWebUrl : 'https://www.techtarget.com';
}